import React from 'react';
import { NavLink, NavLinkRenderProps,useNavigate  } from 'react-router-dom';

// 1. استيراد الـ hook والسياق اللازم
import { useApp } from '../../contexts/AppContext'; 
import styles from './Layout.module.css';
import { useAuth } from '../../hooks/useAuth'; // استيراد hook المصادقة
// ... (استيراد الأيقونات ومكون Icon)
import {
  FaTachometerAlt,
  FaUserTie,
  FaFileInvoice,
  FaExclamationTriangle,
  FaUser,
  FaSignOutAlt,
} from 'react-icons/fa';
import Icon from '../common/Icon';

const Sidebar: React.FC = () => {
  // 2. الحصول على حالة القائمة من السياق
  const { isSidebarOpen } = useApp();
  const { logout } = useAuth(); // 2. الحصول على دالة logout
  const navigate = useNavigate();

  const getNavLinkClass = ({ isActive }: NavLinkRenderProps): string => {
    return isActive ? `${styles.navLink} ${styles.active}` : styles.navLink;
  };
 // 3. إنشاء دالة لمعالجة تسجيل الخروج
  const handleLogout = () => {
    logout();
    // توجيه المستخدم إلى صفحة تسجيل الدخول بعد الخروج
    navigate('/directory'); 
  };
  return (
    
      
    <aside className={`${styles.sidebar} ${isSidebarOpen ? styles.open : ''}`}>
      <div className={styles.logo}>
        <h3>لوحة التحكم</h3>
      </div>
      <div className={styles.sidebarMain}>
      <nav className={styles.nav}>
        {/* ... باقي روابط NavLink كما هي ... */}
        <NavLink to="/admin/dashboard" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>لوحة التحكم</span>
        </NavLink>
        <NavLink to="/admin/users/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة المستخدمين</span>
        </NavLink>
         <NavLink to="/admin/service-requests/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة الطلبات</span>
        </NavLink>
        <NavLink to="/admin/manage-communiques" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة البلاغات</span>
        </NavLink>
        <NavLink to="/admin/communiques/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>قائمة البلاغات</span>
        </NavLink>
        

        <NavLink to="/admin/subscriptions/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة الاشتراكات</span>
        </NavLink>

        <NavLink to="/admin/subscribers/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة المشتركين </span>
        </NavLink>
        <NavLink to="/admin/invoices/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة الفواتير </span>
        </NavLink>
        
         <NavLink to="/admin/complaints/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة الشكاوى </span>
        </NavLink>

        <NavLink to="/admin/notifications/list" className={getNavLinkClass}>
          
          <Icon as={FaUser} style={styles.icon} />
          <span>ادارة التنبيهات </span>
        </NavLink>
        
        
        <NavLink to="/admin/user-approvals" className={getNavLinkClass}>
         
         <Icon as={FaTachometerAlt} style={styles.icon} />
          <span>الموافقة</span>
        </NavLink>
        
        <NavLink to="/admin/lawyers/list" className={getNavLinkClass}>
         
         <Icon as={FaUserTie} style={styles.icon} />
          <span>المحامين</span>
        </NavLink>

        <NavLink to="/admin/subscribers/training-requests" className={getNavLinkClass}>
         
         <Icon as={FaUserTie} style={styles.icon} />
          <span>طلبات الالتحاق بالتدريب</span>
        </NavLink>
        
        <NavLink to="/admin/services-management" className={getNavLinkClass}>
          
           <Icon as={FaFileInvoice} style={styles.icon} />
          <span>الخدمات</span>
        </NavLink>

        <NavLink to="/admin/trainees/list" className={getNavLinkClass}>
          
          
          <Icon as={FaExclamationTriangle} style={styles.icon} />
          <span>المتدربين</span>
        </NavLink>

        <NavLink to="/profile" className={getNavLinkClass}>
          <Icon as={FaUser} style={styles.icon} />
         
          <span>الملف الشخصي</span>
        </NavLink>

        <NavLink to="/admin/data-import" className={getNavLinkClass}>
          <Icon as={FaUser} style={styles.icon} />
         
          <span>استيراد البيانات</span>
        </NavLink>
        
        
      </nav>
      </div>
   
      <div className={styles.sidebarFooter}>
        <button onClick={handleLogout} className={styles.logoutButton}>
          <Icon as={FaSignOutAlt} />
          <span>تسجيل الخروج</span>
        </button>
      </div>
      
    </aside>
  );
};

export default Sidebar;
